import React from 'react';
import { Box, Button } from '@mui/material';
import { isReadOnly } from '../../../../utils/permissionUtils';

const LogsChecklistRightPanel = ({
    downloadButtons = [],
}) => {

    return (
        <Box p={2}>
            {/* Download Section - Only show if there are buttons to display */}
            {downloadButtons.length > 0 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {downloadButtons.map((button) => (
                        <Button
                            key={button.id}
                            variant="text"
                            onClick={button.handler}
                            disabled={button.disabled ||isReadOnly()}
                            sx={{
                                justifyContent: 'flex-start',
                                padding: "5px 0px",
                                color: button.disabled ? '#b0b0b0' : '#1976d2',
                                textTransform: 'none',
                                fontSize: '18px',
                                cursor: button.disabled ? 'default' : 'pointer',
                                '&:hover': {
                                    backgroundColor: button.disabled
                                        ? 'transparent'
                                        : 'rgba(25, 118, 210, 0.08)'
                                }
                            }}
                        >
                            {button.label}
                        </Button>
                    ))}
                </Box>

            )}
        </Box>
    );
};

export default LogsChecklistRightPanel;